import { getStudySlug } from "../helper/study";
import { ProjectConfig } from "./types";
import { mentalplus } from "./mentalplus";
import { outborn } from "./outborn";

export * from "./types";

const PROJECTS: Record<string, ProjectConfig> = {
  mentalplus,
  outborn,
};

/** Experience-free fallback for studies without a project entry. */
const DEFAULT_PROJECT: ProjectConfig = {
  slug: "",
  homeExperience: "questionnaires",
  tabs: ["questionnaires", "account"],
  // TODO(theme): mirrors outborn's placeholder — amber/sky swapped so CTAs
  // (secondary) get the strong amber under the new role semantics.
  theme: {
    colors: {
      primary: "#2563eb",
      secondary: "#f59e0b",
      accent: "#7dd3fc",
      background: "#ffffff",
      surface: "#eff6ff",
      text: "#0f172a",
    },
  },
};

/**
 * Resolve the active project's config. The slug can come straight from the URL
 * (typed/bookmarked, any casing); no argument = the deployment's own slug.
 */
export function getProjectConfig(slug?: string): ProjectConfig {
  const key = (slug ?? getStudySlug())?.toLowerCase();
  return (key && PROJECTS[key]) || DEFAULT_PROJECT;
}
